// extracted by mini-css-extract-plugin
export default {"container":"styles_container__kDa2h","subtitle":"styles_subtitle__qUB-n","secondary":"styles_secondary__vaA50","title":"styles_title__mpeA4","highlight":"styles_highlight__PdB4d"};